import Cpdf from './CPdf.vue';
const install = function(Vue, opys = {}) {
        Vue.component(Cpdf.name, Cpdf);
    }
    //install();
export default Cpdf;


// WEBPACK FOOTER //
// ./src/components/plugin/vue-pdfviewer/index.js